import React from 'react';
import { forwardRef } from 'react';

import clsx from 'classnames';

export const Checkbox = forwardRef(
  (
    {
      children,
      className,
      disabled,
      error,
      id = 'ID',
      name = 'Name',
      onClick,
      ...props
    },
    ref
  ) => {
    const checkboxClass = clsx(
      {
        'cdl-checkbox': true,
        'cdl-checkbox--error': error,
        'cdl-checkbox--disabled': disabled,
      },
      className
    );
    return (
      <label className={checkboxClass} htmlFor={id} {...props}>
        <input
          ref={ref}
          className="cdl-checkbox__input"
          disabled={disabled}
          id={id}
          name={name}
          onClick={onClick}
          type="checkbox"
        />
        <span className="cdl-checkbox__checkmark" />
        <span className="cdl-checkbox__label">{children}</span>
      </label>
    );
  }
);
